import ResourceData from './Resource'
import InfoCardData from './CardData'
import StateDisTable from './Red_Table'
import GlobalDataRed from './Red_GlobalData'
import { combineReducers } from 'redux';
const CombReducers = combineReducers({
    InfoCardData: InfoCardData,
    ResourceData: ResourceData,
    StateDisTable: StateDisTable,
    GlobalDataRed:GlobalDataRed
});
export default CombReducers
